(() => {
  if (customElements.get('teching-product-share')) return;

  class TechingProductShare extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.trigger = this.querySelector('[data-share-trigger]');
      this.dialog = this.querySelector('[data-share-dialog]');
      this.urlInput = this.querySelector('[data-share-url]');
      this.status = this.querySelector('[data-share-status]');
      if (!this.trigger || !this.dialog || !this.urlInput || !this.status) return;
      const options = {signal: this.controller.signal};
      this.trigger.addEventListener('click', () => this.share(), options);
      this.querySelector('[data-share-close]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-share-copy]').addEventListener('click', () => this.copy(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.status.textContent = '';
        if (this.trigger.isConnected) this.trigger.focus({preventScroll: true});
      }, options);
      this.trigger.hidden = false;
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }

    getShareUrl() {
      const url = new URL(this.dataset.url, window.location.origin);
      url.search = '';
      url.hash = '';
      if (this.dataset.hasVariants === 'true') {
        const form = document.getElementById(this.dataset.formId);
        const variant = form?.querySelector('[name="id"]')?.value || new URL(window.location.href).searchParams.get('variant');
        if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
      }
      return url.href;
    }

    async share() {
      const url = this.getShareUrl();
      const title = this.dataset.title;
      if (window.matchMedia('(pointer: coarse)').matches && typeof navigator.share === 'function') {
        this.trigger.disabled = true;
        try {
          await navigator.share({title, url});
          return;
        } catch (error) {
          if (error?.name === 'AbortError') return;
        } finally {
          this.trigger.disabled = false;
        }
      }
      this.urlInput.value = url;
      this.status.textContent = '';
      this.querySelector('[data-share-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(title + '\n' + url);
      this.querySelector('[data-share-facebook]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
      this.querySelector('[data-share-email]').href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(title + '\n' + url);
      if (!this.dialog.open) this.dialog.showModal();
    }

    async copy() {
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(this.urlInput.value);
        this.status.textContent = this.dataset.copied;
      } catch (_) {
        this.urlInput.focus();
        this.urlInput.select();
        this.urlInput.setSelectionRange(0, this.urlInput.value.length);
        this.status.textContent = this.dataset.manual;
      }
    }
  }

  customElements.define('teching-product-share', TechingProductShare);
})();
